import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // The marketing site (Home / order) does not need Supabase. Don't call createClient
  // with an undefined URL — it throws "supabaseUrl is required" and white-screens the
  // whole app. Disable auth features gracefully instead.
  console.warn('Supabase env vars missing — auth features disabled; marketing site still renders.');
}

export const supabase = (supabaseUrl && supabaseAnonKey)
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;